/**
 * Wish Pool Admin API
 * All calls go through apiClient which prefixes /v1/admin
 */

import apiClient from '@/lib/api/client';
import type {
  AdminClusterListResponse,
  ClusterDetailResponse,
  ClusterUpdateRequest,
  ClusterMergeRequest,
  NotifyResponse,
} from './types';

export interface ClusterListParams {
  status?: string;
  sort_by?: string;
  limit?: number;
  offset?: number;
}

export const wishesApi = {
  listClusters: async (params: ClusterListParams = {}): Promise<AdminClusterListResponse> => {
    const { data } = await apiClient.get('/wish-clusters', { params });
    return data;
  },

  getCluster: async (clusterId: number): Promise<ClusterDetailResponse> => {
    const { data } = await apiClient.get(`/wish-clusters/${clusterId}`);
    return data;
  },

  updateCluster: async (clusterId: number, update: ClusterUpdateRequest): Promise<void> => {
    await apiClient.patch(`/wish-clusters/${clusterId}`, update);
  },

  mergeClusters: async (body: ClusterMergeRequest): Promise<void> => {
    await apiClient.post('/wish-clusters/merge', body);
  },

  notifyCluster: async (clusterId: number): Promise<NotifyResponse> => {
    const { data } = await apiClient.post(`/wish-clusters/${clusterId}/notify`);
    return data;
  },

  deleteWish: async (wishId: number): Promise<void> => {
    await apiClient.delete(`/wish-clusters/wishes/${wishId}`);
  },
};
